<section class="container pt-3">
  <form class="form-container form-horizontal form-postad" #postad="ngForm">
    <ng-container *ngIf="job && user">
      <div class="col-12 col-md-7">
        <div class="form-group">
          <input type="file" #file (change)="loadImage(file.files[0])" style="display:none;" accept=".jpg,.jpeg,.png">
          <button class="btn" type="button" (click)="file.click()">انتخاب تصویر</button>
        </div>
        <div class="form-group">
          <div>نام شرکت (اختیاری):</div>
          <input type="text" class="form-control" name="company" placeholder="نام شرکت (اختیاری)"
            [(ngModel)]="job.Company">
        </div>
        <div class="form-group">
          <h6>زمینه فعالیت (صنعت):</h6>
          <app-option-selector name="industries" [(ngModel)]="job.Industries" [canAdd]="true" [multiple]="true"></app-option-selector>
        </div>
        <div class="form-group">
          <div>عنوان شغلی</div>
          <input type="text" class="form-control" name="title" autofocus required placeholder="عنوان شغلی"
            [(ngModel)]="job.Title">
        </div>
        <div class="form-group clearfix">
          <div>شهر (جستجو کنید):</div>
          <app-location name="location" [accept-level]="0" [(ngModel)]="job"></app-location>
        </div>
        <div class="form-group" *ngIf="job.City">
          <div>محله</div>
          <input type="text" class="form-control" name="district" placeholder="محله" [(ngModel)]="job.District" />
        </div>
        <div class="form-group">
          <div>توضیحات شغل</div>
          <angular-editor placeholder="توضیحات کامل شغل، شرح وظایف، شرایط استخدام، نیازمندی‌ها و ..." name="description"
          [class.editor-ltr]="job.IsLtr" [(ngModel)]="job.Description" [config]="Common.EditotConfig_User"></angular-editor>

          <!-- <app-ngx-editor name="description" placeholder="توضیحات شغل" height="300px" [(ngModel)]="job.Description"
            [toolbar]='[["bold","unorderedList","orderedList"],["link", "unlink"]]'
            [class.editor-ltr]="job.IsLtr">
          </app-ngx-editor> -->
          <label class="pt-1">
            <input type="checkbox d-inline-block" name="types" [(ngModel)]="job.IsLtr">
            <span>متن آگهی به زبان انگلیسی است.</span>
          </label>
  
        </div>
        <div class="form-group">
          <div>مهارت‌های مورد نیاز</div>
            <skill-selector name="skills" [(ngModel)]="job.RequiredSkills" ></skill-selector>
        </div>
        <h6 class="pt-3">نحوه همکاری</h6>
        <div class="form-group group-box">
          <label>
            <input type="checkbox" name="types" [checked]="hasKey(job.JobTypes,'تمام‌وقت')"
              (change)="setKey(job.JobTypes,'تمام‌وقت',$event)">
            <span>تمام‌وقت</span>
          </label>
          <label>
            <input type="checkbox" name="types" [checked]="hasKey(job.JobTypes,'پاره‌وقت')"
              (change)="setKey(job.JobTypes,'پاره‌وقت',$event)">
            <span>نیمه‌وقت</span>
          </label>
          <label>
            <input type="checkbox" name="types" [checked]="hasKey(job.JobTypes,'پروژه‌ای')"
              (change)="setKey(job.JobTypes,'پروژه‌ای',$event)">
            <span>پروژه‌ای</span>
          </label>
          <label>
            <input type="checkbox" name="types" [checked]="hasKey(job.JobTypes,'موقت')"
              (change)="setKey(job.JobTypes,'موقت',$event)">
            <span>موقت</span>
          </label>
          <label>
            <input type="checkbox" name="types" [checked]="hasKey(job.JobTypes,'کاراموزی')"
              (change)="setKey(job.JobTypes,'کاراموزی',$event)">
            <span>کاراموزی</span>
          </label>
        </div>
        <h6 class="pt-3">امکان دورکاری</h6>
        <div class="form-group group-box">
          <label class="pt-1 d-inline-block">
            <input type="checkbox" name="isRemote" [(ngModel)]="job.IsRemote">
            <span>امکان دورکاری دارد</span>
          </label>
        </div>
        <h6 class="pt-3">مدرک تحصیلی</h6>
        <div class="form-group group-box">
          <label>
            <input type="radio" name="educations" [checked]="!job.Educations?.length" (change)="job.Educations=[]">
            <span>مهم‌نیست</span>
          </label>
          <label>
            <input type="radio" name="educations" [checked]="hasKey(job.Educations,'دیپلم')"
              (change)="job.Educations=['دیپلم']">
            <span>دیپلم</span>
          </label>
          <label>
            <input type="radio" name="educations" [checked]="hasKey(job.Educations,'کاردانی')"
              (change)="job.Educations=['کاردانی']">
            <span>کاردانی</span>
          </label>
          <label>
            <input type="radio" name="educations" [checked]="hasKey(job.Educations,'کارشناسی')"
              (change)="job.Educations=['کارشناسی']">
            <span>کارشناسی</span>
          </label>
          <label>
            <input type="radio" name="educations" [checked]="hasKey(job.Educations,'کارشناسی‌ارشد')"
              (change)="job.Educations=['کارشناسی‌ارشد']">
            <span>کارشناسی‌ارشد</span>
          </label>
          <label>
            <input type="radio" name="educations" [checked]="hasKey(job.Educations,'دکترا')"
              (change)="job.Educations=['دکترا']">
            <span>دکترا</span>
          </label>
        </div>

        <h6 class="pt-3">تاریخ انقضا</h6>
        <div class="form-group">
          <div class="col-6">{{job.ExpirationTime|pdate}}</div>
          <app-calendar class="col-6" required name="expiration-time" [(ngModel)]="job.ExpirationTime"></app-calendar>
        </div>

        <div class="alert alert-primary">
          <h6 class="text-center my-3 fs-xl">بودجه‌ی آگهی: {{amount|number}}&nbsp;&nbsp;<span>تومان</span></h6>
          <input type="range" name="amount" [(ngModel)]="amount" [step]="step" [min]="job?.Budget || jobService.BasePrice" max="700000"
            class="range">
          <div class="fs-sm mt-2">
            دریافتی شما: {{user.Agent.Percentage}}% + 10,000 = {{amount-job.Budget-payAmount|number}} تومان
            <span class="float-left">قابل پرداخت = {{payAmount|number}} تومان</span>
          </div>
        </div>

        <ng-container *ngIf="job.IsPaid">
          <h6>بودجه آگهی</h6>
          <div class="info-box mb-5 mt-2">
            <strong>بودجه اولیه</strong> : {{job.Budget|number}} تومان<br>
            <strong>بودجه مصرف شده</strong> : {{job.UsedBudget|number}} تومان<br>
            <strong>بودجه باقیمانده</strong> : {{job.Budget-job.UsedBudget|number}} تومان<br>
          </div>
        </ng-container>
      </div>

      <div class="col-12 col-md-5 preview-cntr">
        <h6 class="mt-3">پیش‌ نمایش</h6>
        <section class="form-preview">
          <header class="fs-sm f-gray d-flex">
            {{job.StartTime|pdate:true}}
            <span class="mr-auto" *ngIf="job.Code>0">
              کد آگهی: KP{{job.Code}}
            </span>
          </header>
          <span *ngIf="(image && preview) || currentImage">
            <img [src]="preview||currentImage" style="max-width:150px;max-height:150px">
            <span class="btn btn-red" (click)="removeImage(file)">X</span>
          </span>
          <h6>{{job.Title}}</h6>
          <div class="f-gray">
            <span *ngIf="job.Company">کارفرما: {{job.Company}}</span> {{[job.State,job.City,job.District]|join:'، '}}
          </div>
          <div class="fs-normal my-2 wrap overflow-auto" [innerHTML]="job.Description"></div>
          <div class="f-gray" *ngIf="(job.ContactName || job.Phone || job.Email || job.Address)">
            <small>اطلاعات تماس جهت درخواست برای این فرصت شغلی:</small><br />
            {{[job.ContactName,job.Phone,job.Email,job.Address]|join:'، '}}
          </div>

          <ul class="">
            <li *ngFor="let skill of job.RequiredSkills">{{skill}}</li>
            <li *ngFor="let type of job.JobTypes">{{type}}</li>
            <li *ngIf="job.IsRemote">دورکاری</li>
            <li *ngFor="let education of job.Educations">{{education}}</li>
          </ul>
        </section>
        <!-- <section>
          <ul class="features-cntr">
            <li class="active">
              <i class="fas fa-users"></i>
              <div>تضمین نمایش به <span class="bold" *ngIf="job && view">{{view|number}}</span> کارجو</div>
            </li>
            <li (click)="setMinAmount(50000)" [class.active]="service.email">
              <i class="fas fa-envelope"></i>
              <div>ارسال <span class="bold" *ngIf="service.email">{{amount / service.step * service.email|number}}
                </span>ایمیل به کارجویان مرتبط</div>
            </li>
            <li (click)="setMinAmount(50000)" [class.active]="service.cv">
              <i class="fas fa-file-alt"></i>
              <div>دسترسی رایگان به <span class="bold" *ngIf="service.cv">{{amount / service.step * service.cv|number}}
                </span>رزومه
              </div>
            </li>
            <li (click)="setMinAmount(200000)" [class.active]="service.sms">
              <i class="fas fa-sms"></i>
              <div>ارسال <span class="bold" *ngIf="service.sms">{{amount / service.step * service.sms|number}}
                </span>پیامک به کارجویان مرتبط
              </div>
            </li>
            <li (click)="setMinAmount(200000)" [class.active]="service.instagram_post">
              <i class="fab fa-instagram"></i>
              <div>پست اینستاگرام</div>
            </li>
            <li (click)="setMinAmount(200000)" [class.active]="service.telegram_group">
              <i class="fab fa-telegram-plane">
                <i class="fas fa-comments min"></i>
              </i>
              <div><span class="bold"
                  *ngIf="service.telegram_group">{{amount / service.step * service.telegram_group|number}} </span>پست
                گروهی
                تلگرام
              </div>
            </li>
            <li (click)="setMinAmount(350000)" [class.active]="service.telegram_post">
              <i class="fab fa-telegram-plane"></i>
              <div>پست اختصاصی تلگرام</div>
            </li>
            <li (click)="setMinAmount(350000)" [class.active]="service.instagram_story">
              <i class="fab fa-instagram">
                <i class="fas fa-image min"></i>
              </i>
              <div>استوری اینستاگرام</div>
            </li>
            <li (click)="setMinAmount(350000)" [class.active]="service.push">
              <i class="fas fa-bell"></i>
              <div>ارسال <span class="bold" *ngIf="service.push">{{amount / service.step * service.push|number}}
                </span>نوتیفیکیشن</div>
            </li>
            <li (click)="setMinAmount(350000)" [class.active]="service.reportage">
              <i class="fas fa-ad"></i>
              <div>رپورتاژ آگهی</div>
            </li>
          </ul>
        </section> -->
        <div class="cross-validation-error-message alert alert-danger"
          *ngIf="!postad.valid && (postad.touched || postad.dirty)">
          <ul>
            <li *ngIf="postad.controls.title.errors?.required">عنوان آگهی را وارد کنید</li>
          </ul>
        </div>
      </div>

      <div class="m-3 btn-group">
        <button class="btn btn-yellow save" type="submit" [disabled]="!postad.valid" (click)="save()">ذخیره</button>
      </div>
    </ng-container>
  </form>
</section>